import { AppBar, Box, Toolbar } from "@mui/material";
import SysColumn from "app/class/sys-column";
import { LogicalNode } from "app/types/record-management-types";
import RecordListNavbarActionsComponent from "./RecordListNavbarActions";
import RecordListNavbarRelatedActionsComponent from "./RecordListNavbarRelatedActions";
import RecordListFilterControl from "./RecordListFilterControl";
import RecordListColumnManagerComponent from "./RecordListColumnManager";
import { ColumnPreference } from "../hooks/useColumnPreferences";
import { SortPreferences } from "../hooks/useRecordListSort";

interface RecordListNavbarProps {
    tableName: string;
    columns: SysColumn[];
    appliedFilter: LogicalNode | null;
    onApplyFilter: (filter: LogicalNode | null) => void;
    onClearFilter: () => void;
    sortPreferences: SortPreferences | null;
    onApplySort: (sortPreferences: SortPreferences | null) => void;
    columnPreferences: ColumnPreference[];
    columnPreferencesLoading: boolean;
    onSaveColumnPreferences: (prefs: ColumnPreference[]) => void;
}

const RecordListNavbarComponent = ({
    tableName,
    columns,
    appliedFilter,
    onApplyFilter,
    onClearFilter,
    sortPreferences,
    onApplySort,
    columnPreferences,
    columnPreferencesLoading,
    onSaveColumnPreferences,
}: RecordListNavbarProps) => {
    return (
        <AppBar
            position="relative"
            elevation={1}
            sx={{
                mt: { xs: "10px", sm: "4px" },
                mx: "0.5px",
                width: "auto",
                backgroundColor: "var(--prm-secondary)",
                "--prm-accent-on-surface": "var(--prm-accent-on-secondary)",
                "--prm-outlined-border": "var(--prm-accent-on-secondary)",
                color: "var(--prm-primary-contrast)",
                borderRadius: (theme) => `${theme.shape.borderRadius}px !important`,
                // border: "1px solid rgba(255, 255, 255, 0.16)",
                boxShadow: (theme) => theme.shadows[1],
                overflow: "hidden",
            }}
        >
            <Toolbar
                sx={{
                    minHeight: { xs: "auto !important", sm: "45px !important" },
                    gap: 1,
                    flexWrap: { xs: "wrap", sm: "nowrap" },
                    alignItems: { xs: "stretch", sm: "center" },
                    px: { xs: 1, sm: 2 },
                    py: { xs: 0.75, sm: 0 },
                }}
            >
                <Box sx={{ flex: { xs: "1 1 100%", sm: "0 0 auto" } }}>
                    <RecordListFilterControl
                        appliedFilter={appliedFilter}
                        columns={columns}
                        onApply={onApplyFilter}
                        onClear={onClearFilter}
                        sortPreferences={sortPreferences}
                        onApplySort={onApplySort}
                    />
                </Box>
                <Box sx={{ flexGrow: 1, display: { xs: "none", sm: "block" } }} />
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1,
                        flex: { xs: "1 1 100%", sm: "0 0 auto" },
                        minWidth: 0,
                    }}
                >
                    <RecordListNavbarActionsComponent tableName={tableName} />
                    <RecordListNavbarRelatedActionsComponent tableName={tableName} />
                    <RecordListColumnManagerComponent
                        preferences={columnPreferences}
                        disabled={columnPreferencesLoading}
                        onSave={onSaveColumnPreferences}
                    />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default RecordListNavbarComponent;
